module.exports = __webpack_public_path__ + "ssAndC.82400232e349a4a73ba7d304ee2b0a31.svg";